import { render, staticRenderFns } from "./Baccarat1.vue?vue&type=template&id=7d2c12b8&scoped=true"
import script from "./Baccarat1.vue?vue&type=script&lang=js"
export * from "./Baccarat1.vue?vue&type=script&lang=js"
import style0 from "./Baccarat1.vue?vue&type=style&index=0&id=7d2c12b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2c12b8",
  null
  
)

export default component.exports